import {
  ColumnView as CoreColumnView,
  type IColumnViewProps,
} from "@b2bportal/core-ui";

export const ColumnView = (props: IColumnViewProps) => {
  return <CoreColumnView {...props} hideWeekdayLabels={false} />;
};
